import {useEffect, useState} from "react";
import Modal from "../Modal";
import Switch from "../Switch";
import Button from "../Button";
import Select from "../Select";
import {useBaseArea} from "../../api/base";
import {useSaveAddressInfo} from "../../api/UdianSysUserAddressInfo";
import {isEmptyObj, mediaMatch} from "../../utils";
import {useAsyncEffect} from "ahooks";
import useNotice from "../../hooks/useNotice";
import {useTranslation} from "react-i18next";

export function ModalAddressForm({ visible, onClose, formQuery, submitSuccess }) {
  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countyList, setCountyList] = useState([]);
  const { getArea, loading } = useBaseArea();
  const { loading: submitLoading, submit } = useSaveAddressInfo();
  const notice = useNotice();
  const isMdmax = mediaMatch.isMdmax;
  const { t } = useTranslation();
  const [query, setQuery] = useState({
    linkor: '',
    address: '',
    mobileNo: '',
    provinceId: '',
    cityId: '',
    countyId: '',
    isDefault: 0,
  });
  
  const submitForm = async () => {
    let { data } = await submit(query);
    if (data) {
      notice.success(t('操作成功'));
      submitSuccess(data);
      setQuery({
        linkor: '',
        address: '',
        mobileNo: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        isDefault: 0,
      });
    }
  };
  
  // 获取省份
  const getProvince = async () => {
    let { data } = await getArea({ pcode: -1 });
    
    if (data) {
      setProvinceList(data);
    }
  };
  
  // 获取市
  const getCity = async (option) => {
    let { data } = await getArea({ pcode: option.areacode });
    if (data) {
      setCityList(data);
    }
  };
  
  // 获取区
  const getCounty = async (option) => {
    let { data } = await getArea({ pcode: option.areacode });
    
    if (data) {
      setCountyList(data);
    }
  };
  
  // 选择省市区
  const selectHandle = (areacode, name) => {
    let res = { ...query };
    res[name] = areacode;
    setQuery(res);
  };
  
  // 地址，电话输入
  const inputHandle = (e, name) => {
    let res = { ...query };
    res[name] = e.target.value;
    setQuery(res);
  };
  
  // 切换设为默认地址
  const changeIsDefault = () => {
    let res = { ...query };
    res.isDefault = res.isDefault === 0 ? 1 : 0;
    setQuery(res);
  };
  
  // 选择 省 select
  const getCityHandle = (option) => {
    getCity(option);
    selectHandle(option.areacode, 'provinceId');
  };
  
  // 选择 市 select
  const getCountyHandle = (option) => {
    getCounty(option);
    selectHandle(option.areacode, 'cityId');
  };
  
  useAsyncEffect(async () => {
    if (!formQuery) return;
    if (isEmptyObj(formQuery)) {
      setCityList([]);
      setCountyList([]);
      setQuery({
        linkor: '',
        address: '',
        mobileNo: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        isDefault: 0,
      });
      getProvince();
    } else {
      setQuery(() => ({
        id: formQuery.id,
        linkor: formQuery.linkor,
        address: formQuery.address,
        mobileNo: formQuery.mobileNo,
        provinceId: formQuery.provinceId,
        cityId: formQuery.cityId,
        countyId: formQuery.countyId,
        isDefault: formQuery.isDefault,
      }));
      await getProvince();
      await getCity({ areacode: formQuery.provinceId });
      await getCounty({ areacode: formQuery.cityId });
    }
  }, [formQuery]);
  
  const containerStyle = { flex: 1, marginRight: isMdmax ? 0 : 15 };
  const controlStyle = isMdmax ? {
    marginBottom: 0,
    border: 0,
    borderBottom: '1px solid #ddd'
  } : { marginBottom: 0, };
  
  return (
    <Modal visible={visible}
           onClose={onClose}
           mt="5vh"
           width={630}
           footer={null}
           title={(formQuery.id ? t('修改') : t('新增')) + ' ' + t('收货地址')}>
      <div className="text-center mdmax:px-[15px]">
        <input placeholder={t('请输入收货人姓名')}
               value={query.linkor}
               onChange={(e) => inputHandle(e, 'linkor')}
               className="md:mb-[26px] border-b md:border border-[#ddd] container py-[15px] px-[16px] md:rounded-[5px] text-[14px]">
        </input>
        
        <input placeholder={t('请输入收货人手机号')}
               value={query.mobileNo}
               onChange={(e) => inputHandle(e, 'mobileNo')}
               className="md:mb-[26px] border-b md:border border-[#ddd] container py-[15px] px-[16px] md:rounded-[5px] text-[14px]">
        </input>
        
        <div className="md:flex md:mb-[26px]">
          <Select options={provinceList}
                  loading={loading}
                  onChange={getCityHandle}
                  value={query.provinceId}
                  placeholder={t('请选择')}
                  containerStyle={containerStyle}
                  controlStyle={controlStyle}
                  keyValue={{ label: 'areaname', value: 'areacode' }}/>
          
          <Select options={cityList}
                  loading={loading}
                  onChange={getCountyHandle}
                  value={query.cityId}
                  placeholder={t('请选择')}
                  containerStyle={containerStyle}
                  controlStyle={controlStyle}
                  keyValue={{ label: 'areaname', value: 'areacode' }}/>
          
          <Select options={countyList}
                  loading={loading}
                  onChange={(option) => selectHandle(option.areacode, 'countyId')}
                  value={query.countyId}
                  placeholder={t('请选择')}
                  containerStyle={{ flex: 1 }}
                  controlStyle={controlStyle}
                  keyValue={{ label: 'areaname', value: 'areacode' }}/>
        </div>
        
        <input placeholder={t('请选择收货地址')}
               onChange={(e) => inputHandle(e, 'address')}
               value={query.address}
               className="mb-[26px] border-b md:border border-[#ddd] container py-[15px] px-[16px] md:rounded-[5px] text-[14px]">
        </input>
        
        <div className="mb-[40px] flex text-left items-center">
          <Switch checked={query.isDefault} onChange={changeIsDefault}/>
          <p className="ml-[10px] text-[14px]">{t('设置为默认地址')}</p>
        </div>
        <Button
          onClick={submitForm}
          loading={loading || submitLoading}
          className="text-[14px] rounded-[5px] mdmax:rounded-full
                     bg-[#333] text-white py-[8px] md:w-[240px] mb-[8px] w-[80%]">
          {t('保存')}
        </Button>
      </div>
    </Modal>
  );
}
